import metadata from '@/metadata.json';
export const API_PRODUCTION_ORIGIN = "https://app.longjump.ai";
export const API_DEVELOPMENT_ORIGIN  = "http://localhost:8000";
export const API_BASE_PATH = "/api/v1";

export const MUX_VIDEO_URL_BASE = "https://image.mux.com/";
export const VITE_PUBLIC_POSTHOG_KEY="phc_1MkWN31jxKe3PvGamRG88oRghZGial406sA35EREebN";
export const VITE_PUBLIC_POSTHOG_HOST="https://us.i.posthog.com"
export const CLERK_PUBLIC_KEY="pk_test_YXNzdXJlZC1tYW1tYWwtNTQuY2xlcmsuYWNjb3VudHMuZGV2JA";
export const ABLY_CLIENT_ID="01K6G5729XQ7EFFQKNN5HDF9CQ";
// export const ABLY_LONGJUMP_UPDATES_CHANNEL = "LONGJUMP:UPDATES";
export const ABLY_LONGJUMP_SESSION_CHANNEL = "LONGJUMP:SESSION";

export const BUILD_NUMBER: string = `${metadata.build.major}.${metadata.build.minor}.${metadata.build.revision}`;


export const featureFlags = {
    FILE_UPLOAD_IN_ACTIVITY_STREAM: false,
    COLOR_AVATARS: false
}
